import { render, staticRenderFns } from "./alerts-details.vue?vue&type=template&id=56343e5f&lang=pug&"
import script from "./alerts-details.vue?vue&type=script&lang=ts&"
export * from "./alerts-details.vue?vue&type=script&lang=ts&"
import style0 from "./alerts-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports